import { render } from "./AlertConfirmModal.vue?vue&type=template&id=1985578e"
import script from "./AlertConfirmModal.vue?vue&type=script&lang=js"
export * from "./AlertConfirmModal.vue?vue&type=script&lang=js"

import "./AlertConfirmModal.vue?vue&type=style&index=0&id=1985578e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__